module.exports = __webpack_public_path__ + "static/media/change.db1e0226.jpg";